// extracted by mini-css-extract-plugin
module.exports = {"link":"_2pIMQ","image":"x89TD","root":"_2F-iu"};